import React from 'react';
import { Container } from 'components/UI';
import { Icon, Title } from '@landing/ui';
import LocationMap from './LocationMap/LocationMap';
import { getMeetupDateString } from 'utils';
import { MEETUP_TIME } from 'define';

import * as styles from './Location.module.scss';

export default function Location({ title, address }) {
  const dateConfig = {
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  };
  const preparedDate = `${getMeetupDateString(dateConfig)}, ${MEETUP_TIME}`;

  return (
    <Container className={styles.container} id="address" background="transparent">
      <div className={styles.layout}>
        <Title color="white">{title}</Title>
        <section className={styles.info}>
          <div className={styles.infoItem}>
            <Icon name="clock" className={styles.infoIcon} />
            <span className={styles.infoDescription}>{preparedDate}</span>
          </div>
          <div className={styles.infoItem}>
            <Icon name="marker" className={styles.infoIcon} />
            <span className={styles.infoDescription}>{address}</span>
          </div>
        </section>
        <LocationMap className={styles.mapSection} />
      </div>
    </Container>
  );
}
